import type { Role } from '../types/user';

/**
 * Permissões da UI. O backend continua sendo a autoridade (PRJ-019);
 * aqui apenas escondemos/desabilitamos ações proibidas (PRJ-020 / PRJ-063).
 */
export const PERMISSIONS = [
  // Administração global
  'admin.panel.view',
  'admin.users.manage',
  'admin.spaces.manage',
  'admin.settings.manage',
  'admin.workflow.manage',

  // Projetos
  'project.create',
  'project.activate',
  'project.edit',
  'project.complete',
  'project.members.manage',

  // Tarefas
  'task.create',
  'task.delete',
  'task.edit.critical', // datas, esforço, responsável
  'task.edit.operational', // status, descrição, checklist, comentários
  'task.status.change',

  // Time Sheet
  'timesheet.own.manage',
  'timesheet.team.audit',
] as const;

export type Permission = (typeof PERMISSIONS)[number];

const MEMBER_PERMISSIONS: Permission[] = [
  'task.edit.operational',
  'task.status.change',
  'timesheet.own.manage',
];

const PM_PERMISSIONS: Permission[] = [
  ...MEMBER_PERMISSIONS,
  'project.activate',
  'project.edit',
  'project.complete',
  'project.members.manage',
  'task.create',
  'task.delete',
  'task.edit.critical',
  'timesheet.team.audit',
];

const ADMIN_PERMISSIONS: Permission[] = [
  ...PM_PERMISSIONS,
  'admin.panel.view',
  'admin.users.manage',
  'admin.spaces.manage',
  'admin.settings.manage',
  'admin.workflow.manage',
  'project.create',
];

export const ROLE_PERMISSIONS: Record<Role, readonly Permission[]> = {
  SUPER_ADMIN: ADMIN_PERMISSIONS,
  ADMIN: ADMIN_PERMISSIONS,
  PM: PM_PERMISSIONS,
  MEMBER: MEMBER_PERMISSIONS,
};
